import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var QuestionSquareIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 25 24",
                    children: [
                        _jsx("path", {
                            d: "M23.095 1.415c-.49-.49-1.14-.76-1.83-.76H3.745c-.69 0-1.34.27-1.83.76s-.76 1.14-.76 1.83v17.51c0 .68.28 1.35.76 1.83.49.49 1.14.76 1.83.76h17.51c.69 0 1.34-.27 1.83-.76.48-.48.76-1.15.76-1.83V3.245c0-.69-.27-1.34-.76-1.83h.01zm-1.24 19.35c0 .16-.06.31-.17.42a.59.59 0 01-.42.17H3.745a.59.59 0 01-.42-.17.59.59 0 01-.17-.42V3.245c0-.16.06-.31.17-.42a.59.59 0 01.42-.17h17.51c.16 0 .31.06.42.17.11.11.17.26.17.42v17.51l.01.01z"
                        }),
                        _jsx("path", {
                            d: "M14.765 6.175c-.45-.33-.97-.56-1.51-.67a3.72 3.72 0 00-1.66.04c-.54.13-1.05.39-1.48.75-.43.35-.78.81-1.02 1.31s-.36 1.06-.36 1.62c0 .55.45 1 1 1s1-.45 1-1a1.796 1.796 0 01.65-1.38c.2-.17.44-.29.7-.35.25-.06.53-.07.78-.02a1.802 1.802 0 011.23.91 1.798 1.798 0 01.08 1.53c-.14.33-.36.6-.66.8-.29.2-.64.3-.99.3a.99.99 0 00-1 1v1.86c0 .55.45 1 1 1s1-.45 1-1v-.99c.39-.11.76-.28 1.1-.5.62-.42 1.11-1.01 1.4-1.7.21-.51.31-1.08.28-1.63-.03-.56-.18-1.11-.44-1.6s-.64-.92-1.08-1.26l-.02-.02zm-1.27 9.94a1.408 1.408 0 00-.99-.4c-.18 0-.36.04-.53.1-.17.07-.32.17-.46.31a1.408 1.408 0 00-.41.99c0 .19.04.36.11.54.07.17.17.32.3.45.13.14.29.24.45.3a1.408 1.408 0 001.07.01c.18-.07.33-.17.46-.31.13-.13.23-.28.3-.46.07-.17.1-.35.1-.53 0-.18-.04-.37-.1-.53a1.29 1.29 0 00-.31-.46l.01-.01z"
                        })
                    ]
                })
            })
        ]
    });
};
QuestionSquareIcon.isCarinaIcon = true;
export default QuestionSquareIcon;
